import React from "react";
import { NetworkBackground } from "./app/components/NetworkBackground";
import { Link } from "react-router-dom";

export default function ErrorPage() {

  return (
    <div className="w-screen h-screen grid content-center justify-center">
      <NetworkBackground />
      <div className="mb-56 rounded-xl bg-gray-200 shadow-lg p-8">
        <h1 className="text-center p-8 text-2xl">We’re Sorry, an error occurred.</h1>
        <br />
        <Link
          onClick={() => window.location.reload()}
          className="text-2xl block mx-auto center p-2 text-purple-800 hover:bg-purple-600 hover:text-white rounded-md text-center"
        >
          Refresh Page
        </Link>
      </div>
    </div>
  );
}
